import React from "react";
import {
  AutoComplete,
  Table,
  Tag,
  Card,
  Spin,
  Empty,

} from "antd";
import useSkillMatrixByUser from "./logic/useSkillMatrixByUser";
import "./SkillMatrixByUser.scss";

const levelOptions = [
  { label: "L1 - Beginner", value: 1 },
  { label: "L2 - Intermediate", value: 2 },
  { label: "L3 - Advanced", value: 3 },
  { label: "L4 - Professional", value: 4 },
];

const SkillMatrixByUser = () => {
  const {
    searchText,
    setSearchText,
    userOptions,
    selectedUser,
    setSelectedUser,
    skills,
    setSkills,
    loading,
    searchingUsers,
    fetchSkills,
    debouncedSearch,
  } = useSkillMatrixByUser();

  const handleSelect = async (userId, option) => {
    const selected = option.fullUser;
    setSelectedUser(selected);
    setSearchText(`${selected.firstName} ${selected.lastName}`);
    await fetchSkills(userId);

  };

  const handleClearSearch = () => {
    setSearchText("");
    setSelectedUser(null);
    setSkills([]);

  };
  const columns = [
    {
      title: "Skill",
      dataIndex: "skillName",
      key: "skillName",
    },
    {
      title: "Categories",
      dataIndex: "categories",
      key: "categories",
      render: (categories) => (
        <div className="category-path-wrapper">
          {Array.isArray(categories) && categories.length > 0 ? (
            categories.map((cat, index) => {
              const path = [
                cat.categoryName,
                cat.subCategory,
                cat.subSubCategory,
              ]
                .filter(Boolean)
                .join(" ➤ ");
              return (
                <Tag key={index} className="category-path-tag">
                  {path}
                </Tag>
              );
            })
          ) : (
            <Tag>-</Tag>
          )}
        </div>
      ),
    },
    {
      title: "Level",
      dataIndex: "skillLevel",
      key: "skillLevel",
      render: (level) => {
        const label = levelOptions.find(opt => opt.value === level)?.label || `L${level}`;
        return <Tag color="purple">{label}</Tag>;
      }
    },
    
    {
      title: "Source",
      dataIndex: "source",
      key: "source",
      render: (source) => <Tag color="blue">{source}</Tag>,
    },
    {
      title: "Added At",
      dataIndex: "addedAt",
      key: "addedAt",
      render: (date) => new Date(date).toLocaleDateString(),
    },
  ];

  return (
    <div
      className={`skills-matrix-by-user-container ${
        skills.length > 0 ? "expanded" : "compact"
      }`}
    >
      <Card title="Skill Matrix Search">
        <AutoComplete
          style={{ width: 300, marginBottom: 16 }}
          placeholder="Search by user name"
          value={searchText}
          options={userOptions}
          onSearch={debouncedSearch}
          onSelect={handleSelect}
          onChange={(value) => {
            setSearchText(value);
            if (value === "") handleClearSearch(); 
          }}
          allowClear
          onClear={handleClearSearch}
          notFoundContent={
            searchingUsers ? <Spin size="small" /> : "No users found"
          }
          filterOption={false}
        />

        {selectedUser && !loading && skills.length === 0 ? (
          <div className="empty-skill-placeholder">
            <Empty
              description={`No skills found for ${selectedUser.firstName} ${selectedUser.lastName}`}
              image={Empty.PRESENTED_IMAGE_SIMPLE}
            />
          </div>
        ) : (
          <Table
            columns={columns}
            dataSource={skills}
            rowKey={(record) =>
              `${record.skillName}-${record.addedAt}-${record.source}`
            }
            pagination={{ pageSize: 10 }}
            bordered
          />
        )}
      </Card>
    </div>
  );
};

export default SkillMatrixByUser;
